import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-palmyra',
  templateUrl: './palmyra.component.html',
  styleUrls: ['./palmyra.component.scss']
})
export class PalmyraComponent {
constructor(public dialogRef: MatDialogRef<PalmyraComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


